import React from "react";

import multisort from "multisort";

import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

import { pluralizeText } from "@ip-utils";
import { Card, Chip } from "@ip-widgets";

export default function BankAccounts({ accounts, loading }) {
  accounts = multisort(accounts || [], [
    "~primary",
    "entity",
    "bank",
    "number",
  ]);

  return (
    <Card
      collapsable
      title={`${loading ? "" : accounts.length} Bank ${pluralizeText(
        "Account",
        accounts
      )}`}
    >
      <Card.Body loading={loading}>
        <Grid container spacing={2}>
          {accounts.map((account, key) => (
            <Grid item key={key} xs={12}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{account.bank}</TableCell>
                    <TableCell>
                      <Box textAlign="right" whiteSpace="nowrap">
                        {account.primary && (
                          <Box component="span" marginRight={1}>
                            <Chip color="primary" label="Primary" />
                          </Box>
                        )}
                        <Chip.Entity value={account.entity} />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Account Name</TableCell>
                    <TableCell align="right">{account.name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Account Number</TableCell>
                    <TableCell align="right" className="monospace">
                      {account.number}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
          ))}
        </Grid>
      </Card.Body>
    </Card>
  );
}
